import React, { useEffect } from "react";

// Redux
import { useAppSelector } from "lib/hooks/useDispatch";
import { shallowEqual, useDispatch } from "react-redux";

// components
import Img from "components/Img";
import Loader from "components/UiKit/Loader";

// Actions
import { getListImg } from "reducers/settings";
import * as actionsCreator from "pages/Search/reducer";

// Interface
interface IGallery {
  sketcher?: any;
}

const Container: React.FC<IGallery> = ({ sketcher }) => {
  const dispatch = useDispatch();

  const listImg = useAppSelector(
    (store) => store.settings.listImgs || [],
    shallowEqual
  );
  const loading = useAppSelector(
    (store) => store.settings.loadingListImgs,
    shallowEqual
  );
  const historyStructureSearch = useAppSelector(
    (store) => store.search.historyStructureSearch || [],
    shallowEqual
  );

  useEffect(() => {
    dispatch(getListImg(historyStructureSearch || []));
  }, [historyStructureSearch]);

  const handlerClickStructure = (item: string) => (e: React.MouseEvent) => {
    const target = e.target as HTMLElement;

    if (target.classList.contains("gallery__icon") || target.closest(".gallery__icon")) {
      return;
    }

    sketcher && sketcher.importStructure("smile", item || "");
  };

  const handlerClickDelete = (item: string) => (e: React.MouseEvent) => {
    const target = e.target as HTMLElement;

    if (target.classList.contains("gallery__icon") || target.closest(".gallery__icon")) {
      dispatch(actionsCreator.deleteItemStructureHistory(item));
    }
  };

  return (
    <div className="gallery">
      {loading
        ? <div className="gallery__loader relative">
          <Loader type="circle" color="dark" />
        </div>
        : !!listImg.length ? (
          <div className="gallery__content flex flex-wrap flex-ai-center flex-jc-start">
            {listImg.map((item: any) => {
              return (
                <div
                  key={item.oldItem}
                  onClick={handlerClickStructure(item.oldItem)}
                  className="gallery__box flex flex-ai-center flex-jc-center relative mr10"
                >
								<span
                  onClick={handlerClickDelete(item.oldItem)}
                  className="gallery__icon flex flex-ai-center flex-jc-center"
                >
									<Img
                    isSvg
                    width={15}
                    height={15}
                    name="crossSvg"
                  />
								</span>

                  <Img
                    isPreloader
                    alt="Image history"
                    innerSrc={item?.newItem}
                    className="gallery__image"
                  />
                </div>
              );
            })}
          </div>
        ) : <div className="gallery__no-data flex flex-ai-center">Your search history is empty</div>}
    </div>
  );
};

export default Container;
